document.addEventListener('DOMContentLoaded', () => {
  const CORE_VARIANTS = new Set([54487712891218, 54487712923986, 54487712956754]);
  const drawer = document.querySelector('.tm-cart-drawer');
  const overlay = document.querySelector('.tm-cart-overlay');
  const itemsRoot = document.querySelector('.tm-cart-items');
  const totalRoot = document.querySelector('.tm-cart-total strong');
  const checkoutButton = document.querySelector('.tm-checkout-button');
  const consentInput = document.querySelector('.tm-digital-consent input');
  const cartCountRoots = document.querySelectorAll('.tm-cart-count');
  const menuDrawer = document.querySelector('.tm-menu-drawer');
  const menuOverlay = document.querySelector('.tm-menu-overlay');
  let cartHasItems = false;

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if (!drawer || !overlay || !itemsRoot || !totalRoot) return;

  const escapeHtml = (value = '') => String(value).replace(/[&<>"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;',
  }[character]));

  const money = (cents, currency = 'USD') => new Intl.NumberFormat('en-US', {
    style: 'currency', currency, maximumFractionDigits: 2,
  }).format(cents / 100);

  const request = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {}),
      },
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  };

  const fetchCart = () => request('/cart.js');
  const addVariant = (variant) => request('/cart/add.js', {
    method: 'POST', body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] }),
  });
  const removeLine = (key) => request('/cart/change.js', {
    method: 'POST', body: JSON.stringify({ id: key, quantity: 0 }),
  });

  const closeMenu = () => {
    menuDrawer?.classList.remove('is-open');
    menuOverlay?.classList.remove('is-open');
    menuDrawer?.setAttribute('aria-hidden', 'true');
    menuOverlay?.setAttribute('aria-hidden', 'true');
    document.querySelector('.tm-menu-trigger')?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('tm-menu-open');
  };

  const openCart = () => {
    closeMenu();
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tm-cart-open');
    drawer.querySelector('.tm-cart-close')?.focus();
  };

  const closeCart = () => {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tm-cart-open');
  };

  const openMenu = () => {
    closeCart();
    menuDrawer?.classList.add('is-open');
    menuOverlay?.classList.add('is-open');
    menuDrawer?.setAttribute('aria-hidden', 'false');
    menuOverlay?.setAttribute('aria-hidden', 'false');
    document.querySelector('.tm-menu-trigger')?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('tm-menu-open');
  };

  const updateCheckoutState = () => {
    if (checkoutButton) checkoutButton.disabled = !cartHasItems || !consentInput?.checked;
  };

  const syncAddonButtons = (cart) => {
    const inCart = new Set(cart.items.map((item) => String(item.variant_id)));
    document.querySelectorAll('.tm-addon-toggle').forEach((button) => {
      if (button.getAttribute('aria-busy') === 'true') return;
      const added = inCart.has(String(button.dataset.variant));
      button.classList.toggle('is-added', added);
      button.setAttribute('aria-pressed', String(added));
      const label = button.querySelector('span');
      if (label) label.textContent = added ? 'Remove' : 'Add';
    });
  };

  const renderCart = async (providedCart) => {
    const cart = providedCart || await fetchCart();
    const checkoutLabel = checkoutButton?.firstChild;
    if (checkoutLabel) checkoutLabel.textContent = 'Secure checkout ';
    checkoutButton?.removeAttribute('aria-busy');
    totalRoot.textContent = money(cart.total_price, cart.currency || 'USD');
    cartHasItems = cart.item_count > 0;
    cartCountRoots.forEach((root) => { root.textContent = String(cart.item_count); });
    updateCheckoutState();
    syncAddonButtons(cart);

    if (!cart.items.length) {
      itemsRoot.innerHTML = '<div class="tm-cart-empty"><strong>Your cart is empty.</strong><span>Choose a TailMind level, or add a focused tool below.</span></div>';
      return cart;
    }

    itemsRoot.innerHTML = cart.items.map((item) => `
      <article class="tm-cart-line">
        <img src="${escapeHtml(item.image || '')}" alt="" loading="lazy">
        <div class="tm-cart-line-copy">
          <strong>${escapeHtml(item.product_title)}</strong>
          <span>${escapeHtml(item.variant_title === 'Default Title' ? 'Digital access' : item.variant_title)} · Qty ${item.quantity}</span>
          <button class="tm-cart-remove" type="button" data-key="${escapeHtml(item.key)}">Remove</button>
        </div>
        <strong>${money(item.final_line_price, cart.currency || 'USD')}</strong>
      </article>
    `).join('');

    itemsRoot.querySelectorAll('.tm-cart-remove').forEach((button) => {
      button.addEventListener('click', async () => {
        button.disabled = true;
        button.textContent = 'Removing…';
        try {
          await renderCart(await removeLine(button.dataset.key));
        } catch (error) {
          button.disabled = false;
          button.textContent = 'Try again';
        }
      });
    });
    return cart;
  };

  document.querySelectorAll('.tm-add-to-cart').forEach((button) => {
    button.addEventListener('click', async () => {
      const original = button.innerHTML;
      const chosenVariant = Number(button.dataset.variant);
      button.classList.add('tm-button-loading');
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Preparing your order…';
      try {
        let cart = await fetchCart();
        const chosenAlreadyPresent = cart.items.some((item) => item.variant_id === chosenVariant);
        for (const item of cart.items) {
          if (CORE_VARIANTS.has(item.variant_id) && item.variant_id !== chosenVariant) {
            cart = await removeLine(item.key);
          }
        }
        if (!chosenAlreadyPresent) {
          await addVariant(chosenVariant);
          cart = await fetchCart();
        }
        await renderCart(cart);
        openCart();
      } catch (error) {
        button.textContent = 'Please try again';
        window.setTimeout(() => { button.innerHTML = original; }, 1800);
      } finally {
        button.classList.remove('tm-button-loading');
        button.removeAttribute('aria-busy');
        if (button.textContent !== 'Please try again') button.innerHTML = original;
      }
    });
  });

  document.querySelectorAll('.tm-addon-toggle').forEach((button) => {
    button.addEventListener('click', async () => {
      const label = button.querySelector('span');
      const variant = Number(button.dataset.variant);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Updating…';
      try {
        let cart = await fetchCart();
        const existing = cart.items.find((item) => item.variant_id === variant);
        if (existing) cart = await removeLine(existing.key);
        else {
          await addVariant(variant);
          cart = await fetchCart();
        }
        button.removeAttribute('aria-busy');
        await renderCart(cart);
        openCart();
      } catch (error) {
        button.removeAttribute('aria-busy');
        if (label) label.textContent = 'Try again';
      } finally {
        button.disabled = false;
      }
    });
  });

  document.querySelector('.tm-cart-close')?.addEventListener('click', closeCart);
  document.querySelector('.tm-continue')?.addEventListener('click', closeCart);
  document.querySelectorAll('.tm-cart-trigger').forEach((button) => button.addEventListener('click', async () => {
    await renderCart();
    openCart();
  }));
  document.querySelector('.tm-menu-trigger')?.addEventListener('click', openMenu);
  document.querySelector('.tm-menu-close')?.addEventListener('click', closeMenu);
  menuOverlay?.addEventListener('click', closeMenu);
  menuDrawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeCart();
      closeMenu();
    }
  });
  consentInput?.addEventListener('change', updateCheckoutState);
  checkoutButton?.addEventListener('click', async () => {
    if (!cartHasItems || !consentInput?.checked) return;
    checkoutButton.disabled = true;
    checkoutButton.setAttribute('aria-busy', 'true');
    const checkoutLabel = checkoutButton.firstChild;
    if (checkoutLabel) checkoutLabel.textContent = 'Preparing secure checkout ';
    try {
      await request('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ attributes: {
          'Digital content consent': 'Immediate delivery requested; withdrawal-right acknowledgement accepted in cart',
        } }),
      });
      window.location.href = '/checkout';
    } catch (error) {
      if (checkoutLabel) checkoutLabel.textContent = 'Please try again ';
      checkoutButton.removeAttribute('aria-busy');
      updateCheckoutState();
    }
  });

  renderCart().catch(() => {});
  window.addEventListener('pageshow', () => renderCart().catch(() => {}));
});
